import { helper } from '@ember/component/helper';

export default helper(function lastFourDigits([id]: [number | string | null | undefined]) {
  if (id == null) {
    return '';
  }
  return id.toString().slice(-4);
});
